import {callCallableNativeSafe} from '../utils/callableNativeSafe';

export function workerAccessErrorMessage(error) {
  const code=String(error?.code || '').replace(/^functions\//,'');
  if(code==='permission-denied') return 'Tu cuenta no tiene permiso para gestionar los accesos de este negocio. Entra con la cuenta del dueño o de un administrador autorizado.';
  if(code==='unauthenticated') return 'Tu sesión no está disponible. Vuelve a iniciar sesión e inténtalo de nuevo.';
  if(['deadline-exceeded','unavailable','network-request-failed'].includes(code)) return 'No pudimos confirmar la solicitud. Comprueba tu conexión y vuelve a intentarlo. Crear otra invitación reemplazará la anterior.';
  if(['failed-precondition','invalid-argument','not-found'].includes(code)) return error.message;
  return 'No pudimos preparar la invitación. Inténtalo nuevamente; si continúa, contacta al administrador de Loop.';
}

export async function manageWorkerAccess(businessId, employeeId, operation, profile) {
  const response = await callCallableNativeSafe({
    functionName: 'manageWorkerAccessV2',
    requireAuth: true,
    data: {businessId, employeeId, operation, ...(profile ? {profile} : {})},
  });
  const result = response?.data || response;
  if (!result?.ok) throw new Error('No pudimos confirmar el cambio de acceso. Intenta nuevamente.');
  if(operation === 'invite' && (!result.inviteId || !result.token || !Number.isFinite(Date.parse(result.expiresAt)))) {
    throw new Error('La respuesta de la invitación está incompleta.');
  }
  window.dispatchEvent(new CustomEvent('loop:worker-access-changed', {detail: {businessId, employeeId}}));
  return result;
}
